<template>
  <div>
<!--    <header class="header-area single-page">-->
<!--      <div class="page-title text-center">-->
<!--        <div class="container">-->
<!--          <div class="row">-->
<!--            <div class="col-md-6 offset-md-3">-->
<!--              <h2>Comport</h2>-->
<!--              <p>There spirit beginning bearing the open at own every give appear in third you sawe two boys</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </header>-->
    <!--banner轮播-->
    <div class="swiper-container" id="mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(banner, index) in bannerList" :key="index" >
          <img :src="banner.img"  mode="aspectFill"  style="width: 100%;"/>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <!-- Feature Area Starts -->
<!--    <section class="feature-area section-padding2" style="padding-top: 40px">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>The Mill Brewery</h2>-->
<!--              <p style="font-size: 19px;font-style: normal">Welcome to The Mill Brewery — an independent local brewery and bar, where beer meets friends in the heart of Collingwood, Melbourne.</p>-->
<!--              <p style="font-size: 19px;font-style: normal">We're tucked away just off Smith Street, in an intimate repurposed warehouse setting. We proudly craft exceptional beers and have created an inviting, community-driven space that's become a local legend.</p>-->
<!--              <p style="font-size: 19px;font-style: normal">From easy drinking crushers, to hoppy ales and rich stouts, we always have a wide range of brews for everyone to enjoy.</p>-->
<!--              <router-link to="/blogDetails" class="template-btn">Menu</router-link>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
  </div>
</template>

<script>
  import Swiper from 'swiper'

  export default {
    data () {
      return {
        bannerList: [
          {
            img: '../../static/assets/images/022.jpg'
          },
          {
            img: '../../static/assets/images/023.jpg'
          },
          {
            img: '../../static/assets/images/024.jpg'
          },
          {
            img: '../../static/assets/images/025.jpg'
          },
          {
            img: '../../static/assets/images/026.jpg'
          },
          {
            img: '../../static/assets/images/027.jpg'
          },
          {
            img: '../../static/assets/images/028.jpg'
          },
          {
            img: '../../static/assets/images/029.jpg'
          }
        ]
      }
    },
    watch: {
      banner: {
        handler (newBanner, oldBanner) {
          // 只能监听到轮播图数据已经有了，但是v-for动态渲染结构我们还是没有办法确定的，因此还是需要用nextTick
          // nextTick:  在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM
          this.$nextTick(() => {
            // eslint-disable-next-line no-undef,no-unused-vars
            const mySwiper = new Swiper('.swiper-container', {
              loop: true, // 循环模式选项
              // 如果需要分页器
              pagination: {
                el: '.swiper-pagination',
                // 点击小球的时候也切换图片
                clickable: true
              },
              // 如果需要前进后退按钮
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              // 如果需要滚动条
              scrollbar: {
                el: '.swiper-scrollbar'
              }
            })
          })
        },
        // 立即监听：不管你数据有没有变化，我上来立即监听一次
        immediate: true
      }
    }
  }
</script>

<style>
.el-step.is-center .el-step__description{
  margin-top: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
}
.el-step__icon.is-icon{
  background: aliceblue;
}
.el-collapse{
  border-top: 1px solid #4b4949 !important;
  border-bottom: 1px solid #4b4949 !important;;
}
.el-collapse .el-collapse-item__header {
  background-color: #000;
  padding: 30px 0;
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  border-bottom-color: #4b4949;
}
.el-collapse .el-collapse-item__wrap{
  background-color: #000;
  border-bottom: 1px solid #4b4949;
}
.el-collapse .el-collapse-item__content{
  font-size: 17px;
  color: #cbc9c9;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// JobCategory.vue?507c4e4e